import ModelCard from "./ModelCard.jsx";

export default ModelCard;



// WEBPACK FOOTER //
// ./src/components/pages/Create_portfolio_by_Advisor/model_card/index.js